import React, { useEffect, useState, useRef } from "react";
import moment from "moment-timezone";
import userIcon from "../../assets/images/user.svg";
import deleteIcon from "../../assets/images/delete-icon.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchMoreVoicemails,
  fetchPreferences,
  setVoiceChatPhone,
  fetchVoiceChat,
  UpdateNotesVoicemail,
  onChangeNotes,
  changeVoiceReadStatus,
} from "../../redux/action";
import Avatar from "react-avatar";
import $ from "jquery";
import { encodePhoneNumber } from "../../helpers/Utils";
import { Box, Image } from "@chakra-ui/react";

export default function VoiceMails({
  isSelectEnable,
  voicemails,
  filter,
  activeVoicemail,
  toggleCheckbox,
  setActiveVoicemail,
}) {
  const dispatch = useDispatch();
  const windowSize = useRef([window.innerWidth, window.innerHeight]);
  const preferences = useSelector((state) => state.preferences);

  const handleActiveVoicemail = (voicemail) => {
    setActiveVoicemail(voicemail);
    dispatch(setVoiceChatPhone(voicemail.sender_phone));
    dispatch(changeVoiceReadStatus(voicemail.id));
    dispatch(fetchVoiceChat());
  };

  const getPreferences = () => {
    dispatch(fetchPreferences());
  };

  useEffect(() => {
    getPreferences();
  }, []);

  const handleVoicemailMbl = () => {
    $("#voicemail-list").css("display", "none");
    $("#single-voicemail").css("display", "block");
  };

  const getUnReadBadgeVoice = (item) => {
    const { unread_count_data } = voicemails;
    let currentCount = unread_count_data.filter(
      (val) => val.phone_no == item.phone_no
    );
    return (
      <>
        {currentCount.length ? (
          <span className="messages-count"> {currentCount[0].count}</span>
        ) : (
          ""
        )}
      </>
    );
  };

  function handleScroll() {
    const container = document.getElementById("Voicemails");
    if (
      container.scrollHeight - container.scrollTop ===
      container.clientHeight
    ) {
      dispatch(fetchMoreVoicemails());
    }
  }
  const userSelectedFont = useSelector((state) => state.settings.fontsize);

  return (
    <div id="Voicemails" onScroll={handleScroll} className="mt-4">
      {!voicemails.isLoading ? (
        voicemails.data &&
        voicemails.data.map((voicemail, index) => {
          let local_date = moment
            .utc(voicemail.created_at.replace(/-/g, "/"))
            .local()
            .format("MMM DD, hh:mm A");
          if (
            filter === "all" ||
            (filter === "unread" && voicemail.read_status === 0)
          ) {
            return (
              <div
                key={voicemail.id}
                style={{ cursor: "pointer" }}
                className={`single-message ${
                  voicemail?.phone_no == voicemails?.chat_phone_no && "active"
                }`}>
                <div
                  className="d-flex"
                  onClick={(e) => {
                    if (e.target.tagName.toLowerCase() === "input") return;
                    if (windowSize.current[0] <= 600) handleVoicemailMbl();
                    handleActiveVoicemail(voicemail);
                  }}>
                  <div className="pt-2">
                    {isSelectEnable && (
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          onChange={(e) => toggleCheckbox(e, voicemail)}
                          id="flexCheckDefault"
                        />
                      </div>
                    )}
                  </div>
                  <div className="ms-2">
                    <Avatar
                      size={
                        userSelectedFont === "small"
                          ? 28
                          : userSelectedFont === "medium"
                          ? 30
                          : userSelectedFont === "large"
                          ? 35
                          : 35
                      }
                      name={voicemail.full_name ? voicemail.full_name : "U k"}
                      round
                    />

                    {/*<img src={userIcon} className="img-fluid"/>*/}
                  </div>
                  <div className="ps-2 d-flex flex-column">
                    <Box
                      fontSize={
                        userSelectedFont === "small"
                          ? "14px"
                          : userSelectedFont === "medium"
                          ? "16px"
                          : userSelectedFont === "large"
                          ? "18px"
                          : "18px"
                      }
                      className="user-name">
                      {voicemail.full_name
                        ? voicemail.full_name
                        : encodePhoneNumber(voicemail.sender_phone)}
                    </Box>
                    <Box
                      fontSize={
                        userSelectedFont === "small"
                          ? "11px"
                          : userSelectedFont === "medium"
                          ? "13px"
                          : userSelectedFont === "large"
                          ? "16px"
                          : "16px"
                      }
                      className="date mt-2">
                      {local_date}
                    </Box>
                    <Box
                      fontSize={
                        userSelectedFont === "small"
                          ? "14px"
                          : userSelectedFont === "medium"
                          ? "16px"
                          : userSelectedFont === "large"
                          ? "18px"
                          : "18px"
                      }
                      className="message mt-2">
                      {voicemail &&
                      voicemail.message &&
                      voicemail.message.length > 20
                        ? voicemail.message.slice(0, 20) + "..."
                        : voicemail.message}
                    </Box>
                  </div>
                  <div
                    className="d-flex align-items-center position-absolute controls-position"
                    data-bs-toggle="modal"
                    data-bs-target="#deleteVoiceMail">
                    {getUnReadBadgeVoice(voicemail)}
                    <Image
                      boxSize={
                        userSelectedFont === "small"
                          ? "24px"
                          : userSelectedFont === "medium"
                          ? "26px"
                          : userSelectedFont === "large"
                          ? "30px"
                          : "30px"
                      }
                      src={deleteIcon}
                      className="ms-2 img-fluid"
                    />
                  </div>
                </div>
                <div className="mt-2">
                  {preferences.show_notes ? (
                    <textarea
                      rows={1}
                      placeholder="Enter Notes:"
                      value={voicemail.note}
                      onChange={(e) =>
                        dispatch(UpdateNotesVoicemail(e.target, voicemail))
                      }
                      onBlur={(e) =>
                        dispatch(
                          onChangeNotes(e.target, voicemail, "voicemails")
                        )
                      }
                      className="form-control message textareaexpand"
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
            );
          }
        })
      ) : (
        <div className="loadingMessagesList"></div>
      )}
      {!voicemails.isLoading && voicemails.isMoreLoading && (
        <div className="isMoreLoading" />
      )}
    </div>
  );
}
